import { config } from "../environment";
import { Text } from "./Text";

export function Version() {
  const isValidSha = /^[0-9a-f]{7,40}$/i.test(config.gitSha);
  const githubLink = isValidSha
    ? `https://github.com/tines/3B/commit/${config.gitSha}`
    : null;

  return (
    <div style={{ fontFamily: "var(--font-mono)", padding: "20px" }}>
      <Text variant="code-regular">SHA: {config.gitSha}</Text>
      {githubLink && (
        <>
          <br />
          <Text variant="code-regular">
            GitHub:{" "}
            <a href={githubLink} target="_blank" rel="noopener noreferrer">
              {githubLink}
            </a>
          </Text>
        </>
      )}
    </div>
  );
}
